<div class="waiting-card" data-progress-card>
  <div class="waiting-card__header">
    <div class="waiting-card__logo">
      <img [src]="item?.image" [alt]="item?.name" />
    </div>
    <div class="waiting-card__status">
      <span class="waiting-card__spinner" aria-hidden="true"></span>
      <div class="waiting-card__text">
        <div class="waiting-card__title">
          {{
            (item?.isSlow
              ? "comparison.progress.waitingCardSlowTitle"
              : "comparison.progress.waitingCardTitle"
            ) | translate
          }}
        </div>
        <div class="waiting-card__desc">
          {{
            (item?.isSlow
              ? "comparison.progress.waitingCardSlowDesc"
              : "comparison.progress.waitingCardDesc"
            ) | translate
          }}
        </div>
      </div>
    </div>
  </div>

  <div class="waiting-card__body" aria-hidden="true">
    <div class="waiting-card__skeleton-row">
      <span class="skeleton-bar skeleton-bar--xs"></span>
      <span class="skeleton-bar skeleton-bar--sm"></span>
    </div>
    <span class="skeleton-bar skeleton-bar--md"></span>
    <span class="skeleton-bar skeleton-bar--lg"></span>
    <span class="skeleton-bar skeleton-bar--md"></span>
  </div>

  <div class="waiting-card__footer">
    <button type="button" class="waiting-card__cta" disabled>
      {{ "comparison.progress.awaitingPrice" | translate }}
    </button>
  </div>
</div>
